/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/checkbox/custom-elements';

import { defineCustomElement as defineOsdsCheckbox } from '@ovhcloud/ods-stencil/components/checkbox/custom-elements/osds-checkbox.js';


export const OsdsCheckbox = /*@__PURE__*/ defineContainer<JSX.OsdsCheckbox>('osds-checkbox', defineOsdsCheckbox, [
  'afterSave',
  'ariaLabel',
  'ariaLabelledby',
  'beforeSave',
  'checked',
  'disabled',
  'hasFocus',
  'label',
  'name',
  'save',
  'updating',
  'value',
  'odsBlur',
  'odsCheckedChange',
  'odsFocus',
  'odsUpdatingChange'
]);

